/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BrandInfringement,
  DomainThreat,
  DomainThreatStats,
  InfringementEvent,
  PaginatedBrandInfringementList,
  PaginatedCountStatList,
  PaginatedDomainThreatList,
  PaginatedInfringementEventList,
  PaginatedTakedownEventList,
  PatchedBrandInfringement,
  PatchedDomainThreat,
  PatchedInfringementEvent,
  PatchedTakedownEvent,
  TakedownEvent,
} from '../models/index';
import {
    BrandInfringementFromJSON,
    BrandInfringementToJSON,
    DomainThreatFromJSON,
    DomainThreatToJSON,
    DomainThreatStatsFromJSON,
    DomainThreatStatsToJSON,
    InfringementEventFromJSON,
    InfringementEventToJSON,
    PaginatedBrandInfringementListFromJSON,
    PaginatedBrandInfringementListToJSON,
    PaginatedCountStatListFromJSON,
    PaginatedCountStatListToJSON,
    PaginatedDomainThreatListFromJSON,
    PaginatedDomainThreatListToJSON,
    PaginatedInfringementEventListFromJSON,
    PaginatedInfringementEventListToJSON,
    PaginatedTakedownEventListFromJSON,
    PaginatedTakedownEventListToJSON,
    PatchedBrandInfringementFromJSON,
    PatchedBrandInfringementToJSON,
    PatchedDomainThreatFromJSON,
    PatchedDomainThreatToJSON,
    PatchedInfringementEventFromJSON,
    PatchedInfringementEventToJSON,
    PatchedTakedownEventFromJSON,
    PatchedTakedownEventToJSON,
    TakedownEventFromJSON,
    TakedownEventToJSON,
} from '../models/index';

export interface BrandInfringementsAddTimelineEventCreateRequest {
    id: number;
    teamSlug: string;
    brandInfringement: Omit<BrandInfringement, 'id'|'threat_type_display'|'severity_display'|'status_display'|'date_detected'|'timeline_events'|'created_at'|'updated_at'>;
}

export interface BrandInfringementsCreateRequest {
    teamSlug: string;
    brandInfringement: Omit<BrandInfringement, 'id'|'threat_type_display'|'severity_display'|'status_display'|'date_detected'|'timeline_events'|'created_at'|'updated_at'>;
}

export interface BrandInfringementsDestroyRequest {
    id: number;
    teamSlug: string;
}

export interface BrandInfringementsListRequest {
    teamSlug: string;
    limit?: number;
    page?: number;
}

export interface BrandInfringementsPartialUpdateRequest {
    id: number;
    teamSlug: string;
    patchedBrandInfringement?: Omit<PatchedBrandInfringement, 'id'|'threat_type_display'|'severity_display'|'status_display'|'date_detected'|'timeline_events'|'created_at'|'updated_at'>;
}

export interface BrandInfringementsRetrieveRequest {
    id: number;
    teamSlug: string;
}

export interface BrandInfringementsStatsListRequest {
    teamSlug: string;
    limit?: number;
    page?: number;
}

export interface BrandInfringementsUpdateRequest {
    id: number;
    teamSlug: string;
    brandInfringement: Omit<BrandInfringement, 'id'|'threat_type_display'|'severity_display'|'status_display'|'date_detected'|'timeline_events'|'created_at'|'updated_at'>;
}

export interface BrandTakedownEventsCreateRequest {
    teamSlug: string;
    takedownEvent: Omit<TakedownEvent, 'id'|'event_date'|'created_at'|'updated_at'>;
}

export interface BrandTakedownEventsDestroyRequest {
    id: number;
    teamSlug: string;
}

export interface BrandTakedownEventsListRequest {
    teamSlug: string;
    limit?: number;
    page?: number;
}

export interface BrandTakedownEventsPartialUpdateRequest {
    id: number;
    teamSlug: string;
    patchedTakedownEvent?: Omit<PatchedTakedownEvent, 'id'|'event_date'|'created_at'|'updated_at'>;
}

export interface BrandTakedownEventsRetrieveRequest {
    id: number;
    teamSlug: string;
}

export interface BrandTakedownEventsUpdateRequest {
    id: number;
    teamSlug: string;
    takedownEvent: Omit<TakedownEvent, 'id'|'event_date'|'created_at'|'updated_at'>;
}

export interface BrandThreatsAddTakedownEventCreateRequest {
    id: number;
    teamSlug: string;
    domainThreat: Omit<DomainThreat, 'id'|'threat_type_display'|'affected_domain'|'status_display'|'takedown_events'|'created_at'|'updated_at'>;
}

export interface BrandThreatsCreateRequest {
    teamSlug: string;
    domainThreat: Omit<DomainThreat, 'id'|'threat_type_display'|'affected_domain'|'status_display'|'takedown_events'|'created_at'|'updated_at'>;
}

export interface BrandThreatsDestroyRequest {
    id: number;
    teamSlug: string;
}

export interface BrandThreatsListRequest {
    teamSlug: string;
    limit?: number;
    page?: number;
}

export interface BrandThreatsPartialUpdateRequest {
    id: number;
    teamSlug: string;
    patchedDomainThreat?: Omit<PatchedDomainThreat, 'id'|'threat_type_display'|'affected_domain'|'status_display'|'takedown_events'|'created_at'|'updated_at'>;
}

export interface BrandThreatsRetrieveRequest {
    id: number;
    teamSlug: string;
}

export interface BrandThreatsStatsRetrieveRequest {
    id: number;
    teamSlug: string;
}

export interface BrandThreatsUpdateRequest {
    id: number;
    teamSlug: string;
    domainThreat: Omit<DomainThreat, 'id'|'threat_type_display'|'affected_domain'|'status_display'|'takedown_events'|'created_at'|'updated_at'>;
}

export interface BrandTimelineEventsCreateRequest {
    teamSlug: string;
    infringementEvent: Omit<InfringementEvent, 'id'|'event_date'|'created_at'|'updated_at'>;
}

export interface BrandTimelineEventsDestroyRequest {
    id: number;
    teamSlug: string;
}

export interface BrandTimelineEventsListRequest {
    teamSlug: string;
    limit?: number;
    page?: number;
}

export interface BrandTimelineEventsPartialUpdateRequest {
    id: number;
    teamSlug: string;
    patchedInfringementEvent?: Omit<PatchedInfringementEvent, 'id'|'event_date'|'created_at'|'updated_at'>;
}

export interface BrandTimelineEventsRetrieveRequest {
    id: number;
    teamSlug: string;
}

export interface BrandTimelineEventsUpdateRequest {
    id: number;
    teamSlug: string;
    infringementEvent: Omit<InfringementEvent, 'id'|'event_date'|'created_at'|'updated_at'>;
}

/**
 * 
 */
export class BrandApi extends runtime.BaseAPI {

    /**
     * Add a timeline event to the brand infringement
     */
    async brandInfringementsAddTimelineEventCreateRaw(requestParameters: BrandInfringementsAddTimelineEventCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BrandInfringement>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandInfringementsAddTimelineEventCreate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandInfringementsAddTimelineEventCreate().'
            );
        }

        if (requestParameters['brandInfringement'] == null) {
            throw new runtime.RequiredError(
                'brandInfringement',
                'Required parameter "brandInfringement" was null or undefined when calling brandInfringementsAddTimelineEventCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/infringements/{id}/add_timeline_event/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BrandInfringementToJSON(requestParameters['brandInfringement']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BrandInfringementFromJSON(jsonValue));
    }

    /**
     * Add a timeline event to the brand infringement
     */
    async brandInfringementsAddTimelineEventCreate(requestParameters: BrandInfringementsAddTimelineEventCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BrandInfringement> {
        const response = await this.brandInfringementsAddTimelineEventCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing brand infringements. Includes team-based filtering and proper serializer context handling.
     */
    async brandInfringementsCreateRaw(requestParameters: BrandInfringementsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BrandInfringement>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandInfringementsCreate().'
            );
        }

        if (requestParameters['brandInfringement'] == null) {
            throw new runtime.RequiredError(
                'brandInfringement',
                'Required parameter "brandInfringement" was null or undefined when calling brandInfringementsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/infringements/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BrandInfringementToJSON(requestParameters['brandInfringement']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BrandInfringementFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing brand infringements. Includes team-based filtering and proper serializer context handling.
     */
    async brandInfringementsCreate(requestParameters: BrandInfringementsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BrandInfringement> {
        const response = await this.brandInfringementsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing brand infringements. Includes team-based filtering and proper serializer context handling.
     */
    async brandInfringementsDestroyRaw(requestParameters: BrandInfringementsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandInfringementsDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandInfringementsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/infringements/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ViewSet for managing brand infringements. Includes team-based filtering and proper serializer context handling.
     */
    async brandInfringementsDestroy(requestParameters: BrandInfringementsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.brandInfringementsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * ViewSet for managing brand infringements. Includes team-based filtering and proper serializer context handling.
     */
    async brandInfringementsListRaw(requestParameters: BrandInfringementsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedBrandInfringementList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandInfringementsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/infringements/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedBrandInfringementListFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing brand infringements. Includes team-based filtering and proper serializer context handling.
     */
    async brandInfringementsList(requestParameters: BrandInfringementsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedBrandInfringementList> {
        const response = await this.brandInfringementsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing brand infringements. Includes team-based filtering and proper serializer context handling.
     */
    async brandInfringementsPartialUpdateRaw(requestParameters: BrandInfringementsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BrandInfringement>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandInfringementsPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandInfringementsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/infringements/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedBrandInfringementToJSON(requestParameters['patchedBrandInfringement']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BrandInfringementFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing brand infringements. Includes team-based filtering and proper serializer context handling.
     */
    async brandInfringementsPartialUpdate(requestParameters: BrandInfringementsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BrandInfringement> {
        const response = await this.brandInfringementsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing brand infringements. Includes team-based filtering and proper serializer context handling.
     */
    async brandInfringementsRetrieveRaw(requestParameters: BrandInfringementsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BrandInfringement>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandInfringementsRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandInfringementsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/infringements/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BrandInfringementFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing brand infringements. Includes team-based filtering and proper serializer context handling.
     */
    async brandInfringementsRetrieve(requestParameters: BrandInfringementsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BrandInfringement> {
        const response = await this.brandInfringementsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get brand infringement statistics.
     */
    async brandInfringementsStatsListRaw(requestParameters: BrandInfringementsStatsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedCountStatList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandInfringementsStatsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/infringements-stats/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedCountStatListFromJSON(jsonValue));
    }

    /**
     * Get brand infringement statistics.
     */
    async brandInfringementsStatsList(requestParameters: BrandInfringementsStatsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedCountStatList> {
        const response = await this.brandInfringementsStatsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing brand infringements. Includes team-based filtering and proper serializer context handling.
     */
    async brandInfringementsUpdateRaw(requestParameters: BrandInfringementsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BrandInfringement>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandInfringementsUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandInfringementsUpdate().'
            );
        }

        if (requestParameters['brandInfringement'] == null) {
            throw new runtime.RequiredError(
                'brandInfringement',
                'Required parameter "brandInfringement" was null or undefined when calling brandInfringementsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/infringements/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BrandInfringementToJSON(requestParameters['brandInfringement']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BrandInfringementFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing brand infringements. Includes team-based filtering and proper serializer context handling.
     */
    async brandInfringementsUpdate(requestParameters: BrandInfringementsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BrandInfringement> {
        const response = await this.brandInfringementsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing takedown events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTakedownEventsCreateRaw(requestParameters: BrandTakedownEventsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TakedownEvent>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandTakedownEventsCreate().'
            );
        }

        if (requestParameters['takedownEvent'] == null) {
            throw new runtime.RequiredError(
                'takedownEvent',
                'Required parameter "takedownEvent" was null or undefined when calling brandTakedownEventsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/takedown-events/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TakedownEventToJSON(requestParameters['takedownEvent']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TakedownEventFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing takedown events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTakedownEventsCreate(requestParameters: BrandTakedownEventsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TakedownEvent> {
        const response = await this.brandTakedownEventsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing takedown events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTakedownEventsDestroyRaw(requestParameters: BrandTakedownEventsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandTakedownEventsDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandTakedownEventsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/takedown-events/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ViewSet for managing takedown events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTakedownEventsDestroy(requestParameters: BrandTakedownEventsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.brandTakedownEventsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * ViewSet for managing takedown events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTakedownEventsListRaw(requestParameters: BrandTakedownEventsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedTakedownEventList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandTakedownEventsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/takedown-events/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedTakedownEventListFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing takedown events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTakedownEventsList(requestParameters: BrandTakedownEventsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedTakedownEventList> {
        const response = await this.brandTakedownEventsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing takedown events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTakedownEventsPartialUpdateRaw(requestParameters: BrandTakedownEventsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TakedownEvent>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandTakedownEventsPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandTakedownEventsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/takedown-events/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedTakedownEventToJSON(requestParameters['patchedTakedownEvent']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TakedownEventFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing takedown events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTakedownEventsPartialUpdate(requestParameters: BrandTakedownEventsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TakedownEvent> {
        const response = await this.brandTakedownEventsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing takedown events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTakedownEventsRetrieveRaw(requestParameters: BrandTakedownEventsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TakedownEvent>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandTakedownEventsRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandTakedownEventsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/takedown-events/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TakedownEventFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing takedown events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTakedownEventsRetrieve(requestParameters: BrandTakedownEventsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TakedownEvent> {
        const response = await this.brandTakedownEventsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing takedown events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTakedownEventsUpdateRaw(requestParameters: BrandTakedownEventsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TakedownEvent>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandTakedownEventsUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandTakedownEventsUpdate().'
            );
        }

        if (requestParameters['takedownEvent'] == null) {
            throw new runtime.RequiredError(
                'takedownEvent',
                'Required parameter "takedownEvent" was null or undefined when calling brandTakedownEventsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/takedown-events/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TakedownEventToJSON(requestParameters['takedownEvent']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TakedownEventFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing takedown events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTakedownEventsUpdate(requestParameters: BrandTakedownEventsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TakedownEvent> {
        const response = await this.brandTakedownEventsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a takedown event to the domain threat
     */
    async brandThreatsAddTakedownEventCreateRaw(requestParameters: BrandThreatsAddTakedownEventCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainThreat>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandThreatsAddTakedownEventCreate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandThreatsAddTakedownEventCreate().'
            );
        }

        if (requestParameters['domainThreat'] == null) {
            throw new runtime.RequiredError(
                'domainThreat',
                'Required parameter "domainThreat" was null or undefined when calling brandThreatsAddTakedownEventCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/threats/{id}/add_takedown_event/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DomainThreatToJSON(requestParameters['domainThreat']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainThreatFromJSON(jsonValue));
    }

    /**
     * Add a takedown event to the domain threat
     */
    async brandThreatsAddTakedownEventCreate(requestParameters: BrandThreatsAddTakedownEventCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainThreat> {
        const response = await this.brandThreatsAddTakedownEventCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing domain-based threats. Includes team-based filtering and proper serializer context handling.
     */
    async brandThreatsCreateRaw(requestParameters: BrandThreatsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainThreat>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandThreatsCreate().'
            );
        }

        if (requestParameters['domainThreat'] == null) {
            throw new runtime.RequiredError(
                'domainThreat',
                'Required parameter "domainThreat" was null or undefined when calling brandThreatsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/threats/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DomainThreatToJSON(requestParameters['domainThreat']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainThreatFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing domain-based threats. Includes team-based filtering and proper serializer context handling.
     */
    async brandThreatsCreate(requestParameters: BrandThreatsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainThreat> {
        const response = await this.brandThreatsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing domain-based threats. Includes team-based filtering and proper serializer context handling.
     */
    async brandThreatsDestroyRaw(requestParameters: BrandThreatsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandThreatsDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandThreatsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/threats/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ViewSet for managing domain-based threats. Includes team-based filtering and proper serializer context handling.
     */
    async brandThreatsDestroy(requestParameters: BrandThreatsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.brandThreatsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * ViewSet for managing domain-based threats. Includes team-based filtering and proper serializer context handling.
     */
    async brandThreatsListRaw(requestParameters: BrandThreatsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDomainThreatList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandThreatsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/threats/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDomainThreatListFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing domain-based threats. Includes team-based filtering and proper serializer context handling.
     */
    async brandThreatsList(requestParameters: BrandThreatsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDomainThreatList> {
        const response = await this.brandThreatsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing domain-based threats. Includes team-based filtering and proper serializer context handling.
     */
    async brandThreatsPartialUpdateRaw(requestParameters: BrandThreatsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainThreat>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandThreatsPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandThreatsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/threats/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedDomainThreatToJSON(requestParameters['patchedDomainThreat']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainThreatFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing domain-based threats. Includes team-based filtering and proper serializer context handling.
     */
    async brandThreatsPartialUpdate(requestParameters: BrandThreatsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainThreat> {
        const response = await this.brandThreatsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing domain-based threats. Includes team-based filtering and proper serializer context handling.
     */
    async brandThreatsRetrieveRaw(requestParameters: BrandThreatsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainThreat>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandThreatsRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandThreatsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/threats/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainThreatFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing domain-based threats. Includes team-based filtering and proper serializer context handling.
     */
    async brandThreatsRetrieve(requestParameters: BrandThreatsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainThreat> {
        const response = await this.brandThreatsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get domain threat statistics.
     */
    async brandThreatsStatsRetrieveRaw(requestParameters: BrandThreatsStatsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainThreatStats>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandThreatsStatsRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandThreatsStatsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/threats-stats/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainThreatStatsFromJSON(jsonValue));
    }

    /**
     * Get domain threat statistics.
     */
    async brandThreatsStatsRetrieve(requestParameters: BrandThreatsStatsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainThreatStats> {
        const response = await this.brandThreatsStatsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing domain-based threats. Includes team-based filtering and proper serializer context handling.
     */
    async brandThreatsUpdateRaw(requestParameters: BrandThreatsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainThreat>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandThreatsUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandThreatsUpdate().'
            );
        }

        if (requestParameters['domainThreat'] == null) {
            throw new runtime.RequiredError(
                'domainThreat',
                'Required parameter "domainThreat" was null or undefined when calling brandThreatsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/threats/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DomainThreatToJSON(requestParameters['domainThreat']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainThreatFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing domain-based threats. Includes team-based filtering and proper serializer context handling.
     */
    async brandThreatsUpdate(requestParameters: BrandThreatsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainThreat> {
        const response = await this.brandThreatsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing infringement timeline events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTimelineEventsCreateRaw(requestParameters: BrandTimelineEventsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InfringementEvent>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandTimelineEventsCreate().'
            );
        }

        if (requestParameters['infringementEvent'] == null) {
            throw new runtime.RequiredError(
                'infringementEvent',
                'Required parameter "infringementEvent" was null or undefined when calling brandTimelineEventsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/timeline-events/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InfringementEventToJSON(requestParameters['infringementEvent']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfringementEventFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing infringement timeline events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTimelineEventsCreate(requestParameters: BrandTimelineEventsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InfringementEvent> {
        const response = await this.brandTimelineEventsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing infringement timeline events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTimelineEventsDestroyRaw(requestParameters: BrandTimelineEventsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandTimelineEventsDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandTimelineEventsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/timeline-events/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ViewSet for managing infringement timeline events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTimelineEventsDestroy(requestParameters: BrandTimelineEventsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.brandTimelineEventsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * ViewSet for managing infringement timeline events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTimelineEventsListRaw(requestParameters: BrandTimelineEventsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedInfringementEventList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandTimelineEventsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/timeline-events/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedInfringementEventListFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing infringement timeline events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTimelineEventsList(requestParameters: BrandTimelineEventsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedInfringementEventList> {
        const response = await this.brandTimelineEventsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing infringement timeline events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTimelineEventsPartialUpdateRaw(requestParameters: BrandTimelineEventsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InfringementEvent>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandTimelineEventsPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandTimelineEventsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/timeline-events/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedInfringementEventToJSON(requestParameters['patchedInfringementEvent']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfringementEventFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing infringement timeline events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTimelineEventsPartialUpdate(requestParameters: BrandTimelineEventsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InfringementEvent> {
        const response = await this.brandTimelineEventsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing infringement timeline events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTimelineEventsRetrieveRaw(requestParameters: BrandTimelineEventsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InfringementEvent>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandTimelineEventsRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandTimelineEventsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/timeline-events/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfringementEventFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing infringement timeline events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTimelineEventsRetrieve(requestParameters: BrandTimelineEventsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InfringementEvent> {
        const response = await this.brandTimelineEventsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing infringement timeline events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTimelineEventsUpdateRaw(requestParameters: BrandTimelineEventsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InfringementEvent>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling brandTimelineEventsUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling brandTimelineEventsUpdate().'
            );
        }

        if (requestParameters['infringementEvent'] == null) {
            throw new runtime.RequiredError(
                'infringementEvent',
                'Required parameter "infringementEvent" was null or undefined when calling brandTimelineEventsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/brand/{team_slug}/timeline-events/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InfringementEventToJSON(requestParameters['infringementEvent']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfringementEventFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing infringement timeline events. Includes team-based filtering and proper serializer context handling.
     */
    async brandTimelineEventsUpdate(requestParameters: BrandTimelineEventsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InfringementEvent> {
        const response = await this.brandTimelineEventsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
